import { RouteLocationNormalized } from 'vue-router'
import store from '@/store'
import Urls from '@/lib/urls'
import userGetters from '@/store/userModule/getterTypes'

export const applyPremiumPlanRequired = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next
) => {
  const user = store.getters[userGetters.USER.NAMESPACED]
  const isOnPremiumPlan = user?.plan && user?.plan !== 'free'

  if (to.meta?.premiumPlanRequired && !isOnPremiumPlan) {
    next({
      name: 'plan',
      query: to.name !== 'plan' ? { redirect: Urls.app(to.fullPath) } : null,
    })

    return false
  } else {
    return true
  }
}

export default applyPremiumPlanRequired
